import { Helmet } from 'react-helmet';

type HeadTagProps = {
    title: string;
};

export const HeadTag = ({ title }: HeadTagProps) => {
    return (
        <Helmet>
            <title>{title}</title>
            <link rel="icon" type="image/png" href="/assets/images/favicon.ico" sizes="16x16" />
        </Helmet>  
    )
}